import * as Status from 'constants/statuses';

export default {
  preferredCard: null,
  selectedCard: null,
  status: Status.IDLE,
  // List of cards fetched
  cards: [],
};
